// extracted by mini-css-extract-plugin
module.exports = {"container":"PageContainer_container__1tMk6","additionalMargin":"PageContainer_additionalMargin__2d79U"};